/** @module store/amperix_remote_connection */
import { subscribe } from '@/api/action_cable'
import { getAmperix, openRemoteAccess } from '@/api/amperixes'

const state = () => ({
  deviceIsOnline: false
})

const mutations = {
  SET_CONNECTION_STATUS(state, isOnline) {
    state.deviceIsOnline = isOnline
  }
}

const actions = {
  fetchConnectionStatus: async ({ commit }, { ctxt, serialNumber }) => {
    const rsp = await getAmperix({ ctxt, serialNumber })
    commit('SET_CONNECTION_STATUS', rsp?.payload?.data?.attributes?.connectionStatus === 'CONNECTED')
  },

  openRemoteAccess: async (_, { serialNumber }) => {
    const rsp = await openRemoteAccess({ serialNumber })
    return rsp?.payload?.links?.next
  },

  subscribeToAmperixConnectivityChannel: ({ commit }, { emsId }) => {
    subscribe({
      params: { channel: 'AmperixConnectivityChannel', type: 'RMQ', ems_id: emsId },
      callback: (data) => {
        commit('SET_CONNECTION_STATUS', data.flag === 1)
      },
      commit
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
